import { Inject, Injectable, Injector } from '@angular/core';

import { Utilities_ReportService } from './Utilities.report.index';
import { FootPrintApiManager_ReportService } from './FootPrintApiManager.report.index';


@Injectable({ providedIn: 'root' })
export class app_ReportService {

  constructor(
    private injector: Injector
  ) {
    this.Utilities = this.injector.get(Utilities_ReportService);
    this.FootPrintApiManager = this.injector.get(FootPrintApiManager_ReportService);
  }
    public Utilities: Utilities_ReportService;
    public FootPrintApiManager: FootPrintApiManager_ReportService;

  public app: app_ReportService = this;

  // injecting lazily in order to avoid circular dependencies
}

